export default function LoginRedirect() {
  window.location.href = "https://beszeljegyesulet.hu/wp/wp-login.php";
  return null;
}
